export default {
  locale: "en",
  name: "Modificaciones",
  translation: { displayName: "Translations" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "cancelOnline",
        displayName: "May Cancel online",
      },
      {
        fieldName: "type",
        displayName: "Penalty Type",
        widget: "arrayPropertyRenderer",
        searchCriteria: "type",
        fieldSelector: {
          FIX_AMOUNT: "Fixed amount",
          PERCENTAGE: "Percentage",
          CHARGE_FIRST_NIGHT: "First night",
        },
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "cancelOnline",
        displayName: "May cancel online",
        widget: "checkbox",
      },
      {
        fieldName: "maxRelease",
        displayName: "Start of the cancellation period",
        widget: "cancellationRange",
        helpText: "Sets the start day and time for this penalty (Relative to the checkin date)",
        defaultValue: "undefined",
        optionDisplayFirst: {
          undefined: { label: "Unrestricted" },
          "0": { label: "Same day as the checkin" },
          "1": { label: "1 day before the checkin" },
          "2": { label: "2 days before the checkin" },
          "3": { label: "3 days before the checkin" },
          "4": { label: "4 days before the checkin" },
          "5": { label: "5 days before the checkin" },
          "6": { label: "6 days before the checkin" },
          "7": { label: "7 days before the checkin" },
          "8": { label: "8 days before the checkin" },
          "9": { label: "9 days before the checkin" },
          "10": { label: "10 days before the checkin" },
          "11": { label: "11 days before the checkin" },
          "12": { label: "12 days before the checkin" },
          "13": { label: "13 days before the checkin" },
          "14": { label: "14 days before the checkin" },
          "15": { label: "15 days before the checkin" },
          "16": { label: "16 days before the checkin" },
          "17": { label: "17 days before the checkin" },
          "18": { label: "18 days before the checkin" },
          "19": { label: "19 days before the checkin" },
          "20": { label: "20 days before the checkin" },
          "21": { label: "21 days before the checkin" },
          "22": { label: "22 days before the checkin" },
          "23": { label: "23 days before the checkin" },
          "24": { label: "24 days before the checkin" },
          "25": { label: "25 days before the checkin" },
          "26": { label: "26 days before the checkin" },
          "27": { label: "27 days before the checkin" },
          "28": { label: "28 days before the checkin" },
          "29": { label: "29 days before the checkin" },
          "30": { label: "30 days before the checkin" },
          "35": { label: "35 days before the checkin" },
          "40": { label: "40 days before the checkin" },
          "45": { label: "45 days before the checkin" },
          "50": { label: "50 days before the checkin" },
          "55": { label: "55 days before the checkin" },
          "60": { label: "60 days before the checkin" },
          "90": { label: "90 days before the checkin" },
          "120": { label: "120 days before the checkin" },
          "150": { label: "150 days before the checkin" },
          "180": { label: "180 days before the checkin" },
          "210": { label: "210 days before the checkin" },
          "240": { label: "240 days before the checkin" },
          "270": { label: "270 days before the checkin" },
          "300": { label: "300 days before the checkin" },
          "330": { label: "330 days before the checkin" },
          "360": { label: "360 days before the checkin" },
        },
        optionDisplaySecond: {
          "00:01": { label: "0:01" },
          "01:00": { label: "1:00" },
          "02:00": { label: "2:00" },
          "03:00": { label: "3:00" },
          "04:00": { label: "4:00" },
          "05:00": { label: "5:00" },
          "06:00": { label: "6:00" },
          "07:00": { label: "7:00" },
          "08:00": { label: "8:00" },
          "09:00": { label: "9:00" },
          "10:00": { label: "10:00" },
          "11:00": { label: "11:00" },
          "12:00": { label: "12:00" },
          "13:00": { label: "13:00" },
          "14:00": { label: "14:00" },
          "15:00": { label: "15:00" },
          "16:00": { label: "16:00" },
          "17:00": { label: "17:00" },
          "18:00": { label: "18:00" },
          "19:00": { label: "19:00" },
          "20:00": { label: "20:00" },
          "21:00": { label: "21:00" },
          "22:00": { label: "22:00" },
          "23:00": { label: "23:00" },
          "23:59": { label: "23:59" },
        },
      },
      {
        fieldName: "minRelease",
        displayName: "End of the cancellation period",
        widget: "cancellationRange",
        helpText: "Sets the end day and time for this penalty (Relative to the checkin date)",
        defaultValue: "undefined",
        optionDisplayFirst: {
          undefined: { label: "Unrestricted" },
          "0": { label: "Same day as the checkin" },
          "1": { label: "1 day before the checkin" },
          "2": { label: "2 days before the checkin" },
          "3": { label: "3 days before the checkin" },
          "4": { label: "4 days before the checkin" },
          "5": { label: "5 days before the checkin" },
          "6": { label: "6 days before the checkin" },
          "7": { label: "7 days before the checkin" },
          "8": { label: "8 days before the checkin" },
          "9": { label: "9 days before the checkin" },
          "10": { label: "10 days before the checkin" },
          "11": { label: "11 days before the checkin" },
          "12": { label: "12 days before the checkin" },
          "13": { label: "13 days before the checkin" },
          "14": { label: "14 days before the checkin" },
          "15": { label: "15 days before the checkin" },
          "16": { label: "16 days before the checkin" },
          "17": { label: "17 days before the checkin" },
          "18": { label: "18 days before the checkin" },
          "19": { label: "19 days before the checkin" },
          "20": { label: "20 days before the checkin" },
          "21": { label: "21 days before the checkin" },
          "22": { label: "22 days before the checkin" },
          "23": { label: "23 days before the checkin" },
          "24": { label: "24 days before the checkin" },
          "25": { label: "25 days before the checkin" },
          "26": { label: "26 days before the checkin" },
          "27": { label: "27 days before the checkin" },
          "28": { label: "28 days before the checkin" },
          "29": { label: "29 days before the checkin" },
          "30": { label: "30 days before the checkin" },
          "35": { label: "35 days before the checkin" },
          "40": { label: "40 days before the checkin" },
          "45": { label: "45 days before the checkin" },
          "50": { label: "50 days before the checkin" },
          "55": { label: "55 days before the checkin" },
          "60": { label: "60 days before the checkin" },
          "90": { label: "90 days before the checkin" },
          "120": { label: "120 days before the checkin" },
          "150": { label: "150 days before the checkin" },
          "180": { label: "180 days before the checkin" },
          "210": { label: "210 days before the checkin" },
          "240": { label: "240 days before the checkin" },
          "270": { label: "270 days before the checkin" },
          "300": { label: "300 days before the checkin" },
          "330": { label: "330 days before the checkin" },
          "360": { label: "360 days before the checkin" },
        },
        optionDisplaySecond: {
          "00:01": { label: "0:01" },
          "01:00": { label: "1:00" },
          "02:00": { label: "2:00" },
          "03:00": { label: "3:00" },
          "04:00": { label: "4:00" },
          "05:00": { label: "5:00" },
          "06:00": { label: "6:00" },
          "07:00": { label: "7:00" },
          "08:00": { label: "8:00" },
          "09:00": { label: "9:00" },
          "10:00": { label: "10:00" },
          "11:00": { label: "11:00" },
          "12:00": { label: "12:00" },
          "13:00": { label: "13:00" },
          "14:00": { label: "14:00" },
          "15:00": { label: "15:00" },
          "16:00": { label: "16:00" },
          "17:00": { label: "17:00" },
          "18:00": { label: "18:00" },
          "19:00": { label: "19:00" },
          "20:00": { label: "20:00" },
          "21:00": { label: "21:00" },
          "22:00": { label: "22:00" },
          "23:00": { label: "23:00" },
          "23:59": { label: "23:59" },
        },
      },
      {
        fieldName: "type",
        displayName: "Penalty type (days)",
        widget: "selector",
        optionDisplay: {
          FIX_AMOUNT: {
            label: "Fixed amount",
          },
          PERCENTAGE: {
            label: "Percentage",
          },
          CHARGE_FIRST_NIGHT: {
            label: "First night",
          },
        },
        defaultValue: "FIX_AMOUNT",
      },
      {
        fieldName: "penalty",
        displayName: "Amount",
        widget: "input",
      },
    ],
  },
};
